export default __webpack_public_path__ + "static/media/il.b15ab0fb.svg";